export default "__VITE_ASSET__6c98d317__"